import { render, staticRenderFns } from "./CardMyOfficeSWCX.vue?vue&type=template&id=728d130c&scoped=true&"
import script from "./CardMyOfficeSWCX.vue?vue&type=script&lang=js&"
export * from "./CardMyOfficeSWCX.vue?vue&type=script&lang=js&"
import style0 from "./CardMyOfficeSWCX.vue?vue&type=style&index=0&id=728d130c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d130c",
  null
  
)

export default component.exports